import * as React from "react";

function SvgFront(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 43 60"
      {...{ ...props, ref }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.669 10.353C.669 4.88 5.105.445 10.576.445h31.77v14.1a4.954 4.954 0 01-4.953 4.953H24.407a4.763 4.763 0 00-4.686 4.696v30.837a4.954 4.954 0 01-4.953 4.954H.668V10.353z"
        fill="#001B38"
      />
      <circle
        cx={24.603}
        cy={24.38}
        r={12.861}
        transform="rotate(90 24.603 24.38)"
        fill="url(#front_svg__ic_r4HomeLogoSmall_6890_0)"
      />
      <circle
        opacity={0.5}
        cx={24.603}
        cy={24.38}
        r={12.861}
        transform="rotate(90 24.603 24.38)"
        fill="url(#front_svg__ic_r4HomeLogoSmall_6890_1)"
      />
      <defs>
        <linearGradient
          id="front_svg__ic_r4HomeLogoSmall_6890_0"
          x1={14.963}
          y1={33.437}
          x2={34.436}
          y2={14.097}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0057" stopOpacity={0.16} />
          <stop offset={0.861} stopColor="#FF0057" />
        </linearGradient>
        <linearGradient
          id="front_svg__ic_r4HomeLogoSmall_6890_1"
          x1={14.963}
          y1={33.437}
          x2={34.436}
          y2={14.097}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0057" stopOpacity={0.16} />
          <stop offset={0.861} stopColor="#FF0057" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgFront);
